import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
    position: 'relative',
    borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
    padding: `${theme.spacing(2)} 0`,
  },
  leftIcon: {
    position: 'absolute',
    top: 10,
    left: 0,
    width: 40,
    height: 40,
    borderRadius: 40,
    backgroundColor: theme.palette.action.disabled,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.white,
  },
  textContainer: {
    width: 'calc(100% - 50px)',
    marginLeft: 50,
  },
  dateRow: {
    display: 'flex',
    flexDirection: 'row',
    fontSize: 12,
    marginBottom: theme.spacing(1),
    fontStyle: 'italic',
  },
  date: {
    marginRight: theme.spacing(3),
  },
  correctionContainer: {
    marginBottom: theme.spacing(1),
    fontSize: 13,
  },
  changeContainer: {
    marginTop: theme.spacing(1),
    fontSize: 14,
  },
  bold: {
    fontWeight: 'bold',
  },
  text: {
    fontSize: 14,
  },
  author: {
    marginRight: theme.spacing(2),
  },
  imagesContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    marginTop: theme.spacing(1),
  },
  image: {
    width: 110,
    height: 110,
    '& .MuiButton-label > div': {
      width: '100%',
    },
  },
  whiteIcon: {
    color: theme.colors.white,
  },
  signatureContainer: {
    marginTop: theme.spacing(1),
    borderTop: `1px dashed ${theme.palette.action.disabledBackground}`,
    paddingTop: theme.spacing(1),
  },
  signatureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  signatureImage: {
    height: 50,
    border: `1px solid ${theme.palette.action.disabledBackground}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  signatureTimestamp: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  filesContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: theme.spacing(1),
  },
}));

export default useStyles;
